import React, { useEffect, useContext, useState } from 'react';
import { Icon, Button, Form, Input, Message, Modal, Grid, Image, Header, Divider } from 'semantic-ui-react'
import styles from './LoginNew.module.css';
import useAuth from '../../../hooks/useAuth';
import { useHistory } from "react-router-dom";
import AuthContext from '../../../context/authContext';
import { ConnectWS } from '../../../ConnectWS'
import { useToasts } from 'react-toast-notifications';
import { useCookies } from 'react-cookie';
import { SCezarencrypt, SCezardecrypt, changeInitialScale, getBGLogin } from "../../../myfunctions"
import LogoTeamLigaGenerator from '../../../assets/tglogov6_small.png';

import ShowInfoTestPlayer from '../../../tools/ShowInfoTestPlayer';

import RegistrationNew from './RegistrationNew';
import SearchLic from '../../../tools/SearchLic';

function LoginNew() {
    const { addToast } = useToasts();
    const [auth, setAuth] = useAuth();// eslint-disable-line no-unused-vars
    const authContext = useContext(AuthContext);
    const [openLogowanie, setOpenLogowanie] = useState(false)
    const [showBtnSendMail, setshowBtnSendMail] = useState(false)
    const [loginStatus, setloginStatus] = useState(null);
    const [loading, setloading] = useState(false);
    const [loadingRestorePass, setloadingRestorePass] = useState(false);
    const [CheckboxS, setCheckboxS] = useState(false);

    const [showRegistration, setshowRegistration] = useState(false);

    const [cookies, setCookie, removeCookie] = useCookies(['UserData']);
    let history = useHistory();
    const [form, setForm] = useState({
        password: '',
        email: '',
    });

    const [random, setrandom] = useState("https://turniej-generator.pl/img/bg/bgsmall2.jpg");

    let urlImageBg = getBGLogin()


    useEffect(() => {
        setrandom(urlImageBg[Math.floor(Math.random() * urlImageBg.length)])
        changeInitialScale(1)

        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
            console.log("View: Login")
        }

        if (cookies.UserData) {
            setForm({ ...form, password: SCezardecrypt(cookies.UserData.password), email: cookies.UserData.email })
            setCheckboxS(true)
        }
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    function submitLogin(e, p) {


        setloginStatus(null)
        setloading(true)
        setshowBtnSendMail(false)
        let email = e ? e : form.email
        let password = p ? p : form.password


        if (CheckboxS) {
            let expiresdate = new Date();
            let today = new Date();
            expiresdate.setDate(today.getDate() + 30);
            setCookie('UserData', { email: email, password: SCezarencrypt(password) }, { path: '/', expires: expiresdate });
        }

        ConnectWS("/login", null, { email: email, password: password }, function (response, logout) {

            if (logout === 1) {
                setloginStatus({ value: response.error, error: true, success: false })
                if (response.status === 4) {
                    setshowBtnSendMail(true)
                }
            } else if (response && response.status && Number(response.status) === 200) {
                let userInfo = { fullName: response.data.fullname, imgProfile: response.data.imgProfile, userId: response.data.userId, email: response.data.email, admin: response.data.admin, s: password, subscription_info: response.data.subscription_info, ai:response.data["AI"] }
                authContext.changeUser(userInfo);
                authContext.changeToken(response.data.token);
                authContext.changeView({ myView: "MyAccount" });
                setAuth(true, response.data.token, JSON.stringify(userInfo));
                addToast('Logowanie prawidłowe', { appearance: 'success' });
                if (window.location.pathname.includes("resetPassword")) {
                    setTimeout(function () { history.push("/") }, 1000);
                }

                closeOpenModal()
            } else {
                setloginStatus({ value: response.error, error: true, success: false })
                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)


        });


    }

    function remindPass(){

        setloginStatus(null)
        setshowBtnSendMail(false)
       
       
        if (typeof form.email === 'undefined' || form.email.length < 3 || form.email.indexOf("@") < 1) {
            setloginStatus({ value: "Wpisz prawidłowy adres e-mail", error: true, success: false })
            return
        }
        let email = form.email
        setloadingRestorePass(true)
        ConnectWS("login/resetPassword", null, { email: email, generatorTL: 1 }, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setloginStatus({ value: response.data.message, error: false, success: true })

            } else {
                setloginStatus({ value: response, error: true, success: false })

                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)
            setloadingRestorePass(false)


        });
    }

    const resendActivationEmail = e => {
        e.preventDefault();
        setloginStatus(null)
        setshowBtnSendMail(false)
        let email = form.email
        ConnectWS("/login/resendActivationEmail", null, { email: email, generatorTL: 1 }, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setloginStatus({ value: response.data.message, error: false, success: true })

            } else {
                setloginStatus({ value: response, error: true, success: false })

                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }
            setloading(false)


        });

    }

    function closeOpenModal() {
        setOpenLogowanie(false)
        authContext.changeModalInfo(false)
    }



    const onChangeCheckbox = (evt, data) => {

        if (data.checked) {

        }
        else {
            removeCookie('UserData')
        }
        setCheckboxS(data.checked)

    }

    function loginToDemo() {
        setForm({ ...form, email: "demo@turniej-generator.pl", password: "demogenerator" })
        setOpenLogowanie(true)
        /*
       
*/
    }

    function startDemo() {
        setTimeout(() => {
            submitLogin("demo@turniej-generator.pl", "demogenerator")
            closeOpenModal()
        }, 200);
    }




    return (

        <div className={`${styles.with_news_feed}`}>
            <div className={`${styles.news_feed}`}>
              
                <div className={`${styles.news_image}`} style={{ backgroundImage: `url(${random})` }}>

                </div>
                <div className={`${styles.news_caption}`}>
                    <p style={{ marginLeft: 20, fontSize: 14 }}>

                        TurniejGenerator.pl to narzędzie wspomagające organizację i zarządzanie rozgrywkami sportowymi. Ułatwia ono szybkie i intuicyjne tworzenie, monitorowanie turniejów oraz lig.
                        Dzięki naszej aplikacji, można łatwo śledzić statystyki zawodników i drużyn, co pozwala na lepszą analizę wyników i podejmowanie strategicznych decyzji.
                    </p>
                </div>
            </div>
            <div className={`${styles.right_content} `}>

                {showRegistration ? <>
                    <h1 className={`${styles.reglog_header}`}>

                        Rejestracja

                        <small>Rejestracja w systemie daje dostęp wszystkich funkcji serwisu.</small>
                    </h1>


                    <div className={`${styles.reglog_content}`}>
                        <RegistrationNew setshowRegistration={setshowRegistration} />

                    </div>
                </>
                    :
                    <>

                        <h1 className={`${styles.reglog_header}`}>

                            Logowanie

                            <small>Proszę wprowadzić swoje dane logowania, aby uzyskać dostęp do swojego konta.</small>
                        </h1>


                        <div className={`${styles.reglog_content}`}>
                            <Form onSubmit={() => submitLogin()} size='mini'>
                                <Form.Field
                                    control={Input}
                                    required
                                    type="email"
                                    label='E-mail'

                                    placeholder='E-mail'
                                    value={form.email}
                                    onChange={(e, data) => setForm({ ...form, email: data.value })}
                                />
                                <Form.Field
                                    control={Input}
                                    type="password"
                                    required
                                    label='Hasło'
                                    placeholder='Hasło'
                                    value={form.password}
                                    onChange={(e, data) => setForm({ ...form, password: data.value })}
                                />
                                <Form.Group inline>
                                    <Form.Checkbox checked={CheckboxS ? true : false} style={{ 'paddingBottom': '10px' }} onClick={(evt, data) => onChangeCheckbox(evt, data)} inline /><div style={{ marginTop: -9 }}>Pamiętaj moje dane logowania</div>
                                </Form.Group>


                                <Button.Group fluid size='mini'>
                                    <Button style={{ marginTop: 5, marginBottom: 5 }} color='google plus' disabled={loading ? true : false} loading={loading ? true : false} >ZALOGUJ</Button>

                                    <Button.Or text='lub' style={{ marginTop: 5 }} />
                                    <Button type='button' style={{ marginTop: 5, marginBottom: 5 }} color='blue' onClick={() => loginToDemo()} disabled={loading ? true : false} loading={loading ? true : false} >SKORZYSTAJ Z KONTA DEMO</Button>

                                </Button.Group>



                            </Form>

                            {loginStatus ? <Message
                                error={loginStatus.error ? true : false}
                                success={loginStatus.success ? true : false}
                            > {loginStatus.value}{showBtnSendMail ? <Button color='google plus' size='mini' style={{ marginLeft: 5 }} disabled={loading ? true : false} loading={loading ? true : false} onClick={(e) => resendActivationEmail(e)} >Wyślij ponownie maila</Button> : ''}</Message> : ''}


                            <div className="cursorPointer" onClick={() => loadingRestorePass ? "" : remindPass()} style={{ fontSize: 14,marginTop:10,color:"#c23d3d" }}><Icon loading={loadingRestorePass} name={loadingRestorePass ? "spinner" :"key"} />Przypomnienie hasła</div>





                            <Button style={{ marginTop: 20 }} size="mini" color='grey' fluid onClick={() => setshowRegistration(true)} >UTWÓRZ KONTO</Button>

                            <Divider />
                            <SearchLic msize="small" pageLogin={true} />

                            <div style={{ fontSize: 12, marginTop: 20, textAlign: "center" }}>
                                © Turniej-Generator.pl All Right Reserved {new Date().getFullYear()}
                            </div>
                        </div>
                    </>}


            </div>
            <Modal
                dimmer='blurring'
                centered={true}
                onOpen={() => setOpenLogowanie(true)}
                open={openLogowanie}
                size={'large'}

            >
                <Modal.Header>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={12} verticalAlign="middle">
                                <Header as='h2' textAlign='center'>
                                    <Icon name='user secret' color="red" />
                                    <Header.Content>Konto testowe</Header.Content>
                                </Header>
                            </Grid.Column>
                            <Grid.Column width={4} textAlign="right" only='large screen'>
                                <Image floated='right' size='big' alt="logo" centered src={LogoTeamLigaGenerator} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content className='modalBGcolor' scrolling>
                    <ShowInfoTestPlayer fullView={false} />


                    <Button style={{ width: "100%" }} color='blue' onClick={() => startDemo()}>
                        ROZPOCZNIJ
                    </Button>

                </Modal.Content>

            </Modal>
        </div>

    )
}

export default LoginNew;